import { z } from 'zod';
import { Privilegio } from './privilegi';
import { dataOraSchema, idSchema } from '../common';

/**
 * Ruolo = DATO (non enum): una coppia (nome + set di privilegi) gestibile dallo
 * staff Evolfin, memorizzata in lookup table. Vedi
 *.
 *
 * Un utente ha UN ruolo; i privilegi effettivi del principal sono
 * `ruolo.privilegi ∪ privilegi extra dell'utente` (solo additivi, mai deny).
 */

export const ruoloCreateSchema = z.object({
  nome: z.string().trim().min(1).max(80),
  descrizione: z.string().trim().max(500).optional(),
  privilegi: z.array(Privilegio).default([]),
});
export type RuoloCreate = z.infer<typeof ruoloCreateSchema>;

export const ruoloUpdateSchema = ruoloCreateSchema.partial();
export type RuoloUpdate = z.infer<typeof ruoloUpdateSchema>;

export const ruoloSchema = z.object({
  id: idSchema,
  nome: z.string(),
  descrizione: z.string().nullable(),
  privilegi: z.array(Privilegio),
  /** `false` = ruolo di sistema, non modificabile da UI (es. superadmin nascosto). */
  editabile: z.boolean(),
  /** `false` = non assegnabile da UI; si assegna solo da DB. */
  assegnabile: z.boolean(),
  creatoIl: dataOraSchema,
});
export type Ruolo = z.infer<typeof ruoloSchema>;
